// extracted by mini-css-extract-plugin
export default {"mainpage":"Home_mainpage__7BAHy","leftOut":"Home_leftOut__WxRzP","rightOut":"Home_rightOut__GkWyG"};